export default "__VITE_ASSET__BTCoNxCC__"